import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QPointIconModule } from '@qpoint/icons';
import { QPointLoadingSpinnerComponent } from '@qpoint/loading';

@Component({
    selector: 'qpoint-toolbar-btn',
    templateUrl: './toolbar-button.component.html',
    styleUrls: ['./toolbar-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        QPointIconModule,
        QPointLoadingSpinnerComponent
    ]
})
export class QPointToolbarButtonComponent {
  @Input() public iconType;
  @Input() public btnClass: string;
  @Input() public iconColor;
  @Input() public iconRotate: 90 | 180 | 270;
  @Input() public active = false;
  @Input() public label: string;
  @Input() public disabled: boolean;
  @Input() public badgeValue: number;
  @Input() public badgeAnimationActive: boolean;
  @Input() public btnType: 'button' | 'submit' | 'reset' = 'button';
  @Input() public qPointButtonType: 'primary' | 'secondary' = 'secondary';
  @Input() public formId: string | null = null;
  @Output() public btnClick = new EventEmitter<void>();

  @Input()
  public iconClass: string;

  @Input()
  public loading: boolean;

  public get buttonClass(): string {
    let btnClass = '';
    if (this.qPointButtonType === 'primary') {
      btnClass += 'qpoint-toolbar-btn-primary ';
    } else if (this.qPointButtonType === 'secondary') {
      btnClass += 'qpoint-toolbar-btn-secondary ';
    }

    if (this.btnClass) {
      btnClass += this.btnClass;
    }

    if (this.iconClass) {
      btnClass += ' btn-with-icon';
    }

    if (this.active) {
      btnClass += ' active';
    }

    if (this.label) {
      btnClass += ' btn-with-label';
    }

    if (this.loading) {
      btnClass += ' btn-loading disabled';
    }

    if (this.badgeValue) {
      btnClass += ' btn-with-badge';
    }

    return btnClass;
  }

  public emitButtonClick() {
    if (!this.disabled) {
      this.btnClick.emit();
    }
  }

  private isValidLoadingIconClass(iconClass: string) {
    switch (iconClass) {
      case 'sync':
      case 'spinner':
      case 'circle-notch':
      case 'cog':
      case 'sync-alt':
      case 'spinner-third':
        return true;
      default:
        return false;
    }
  }
}
